import React from 'react';

const Header = () => {
    return (
        <div className='text-primary font-bold text-4xl pb-4'>
            <marquee behavior="scroll" direction="left">Welcome to Princes parts</marquee>
        </div>
    );
};

export default Header;